import React, { useState } from "react";
import "../newProviderAppCSS/signUp.css";

const CheckBoxToggle = (props) => {
   let { tempId, className, noteTemplateIdFun } = props;
   const [toggle, setToggle] = useState(tempId);
   return (
      <div
         onClick={(e) => {
            setToggle(toggle);
            e.stopPropagation();
         }}
         className={`d-flex justify-content-center align-items-center ${className}`}
      >
         <label className="vtwo-checkbox-toggle-switch" style={{ width: `${props.width}`, height: `${props.height}` }}>
            <input
               type="checkbox"
               onChange={(e) => {
                  setToggle(!tempId);
                  noteTemplateIdFun(tempId);
               }}
            />
            <span
               className={` ${toggle ? "vtwo-lib-checkbox-toggle-slider" : "vtwo-checkbox-toggle-slider"} round`}
            ></span>
         </label>
      </div>
   );
};

export default CheckBoxToggle;
